import React, { useEffect, useState } from 'react'
import "./core-date-picker.css"

const CoreDatePicker = (props: CoreDatePickerConfig) => {
	return (
		<div className="core-date-picker-root modal-disable-select">
			<span className="datepicker-toggle">
				<span className="datepicker-toggle-button"></span>
				<input type="date" className="datepicker-input" style={{
					background:'#fff url(/assets/core/images/calendar_2.webp) 97% 50% no-repeat'
				}} />
			</span>
		</div>
	);

};

export interface CoreDatePickerConfig {
}

export default CoreDatePicker;